import usStateAll from '../components/Map/usStatesAll'

export default function statesMap() {
  let idNameMap = new Map()
  usStateAll.forEach((value) => {
    idNameMap[value['value']] = value['label']
  })
  return idNameMap
}
